import * as z from "@-/com.npmjs.zod";

export const morphemeDefinitionMorphemeSliceSchema = z.object({
  entries: z.array(z.string()),
  pinyin: z.string(),
});
